<template>
    <div class="orderRow border-bottom">
        <div class="orderRow__item orderRow__item--remove">
            <button @click="showConfirmPopup = true" class="remove-cross remove-cross-small"></button>
        </div>
        <div class="orderRow__item--break"></div>
        <div class="orderRow__item orderRow__item--title text-1">
            {{ name }}
        </div>
        <div v-if="hasGifts">
            <div v-for="gift in gifts" :key="gift.uid">{{$t('components.BasketPackItem.gift')}} {{gift.name}} {{gift.quantity}}x</div>
        </div>
        <div v-if="hasDiscounts">
            <div v-for="discount in discounts" :key="discount.uid">{{discount.description}}</div>
        </div>
        <div class="orderRow__item--break"></div>
        <div class="orderRow__item orderRow__item--md orderRow__item--counter">
            <product-counter
                @input="setQuanitity"
                v-model="item.quantity"
                allow-zero="true"
                :max-value="item.storeQuantity"
                increment-message="Více toho na skladu nemáme"
                :use-max-value="!item.isService"
                :allow-overgrow="item.isService"
                @overgrow="showOvergrowPopup"
            >
            </product-counter>
        </div>
        <div class="orderRow__item orderRow__item--sm text-right orderRow__item--price">
            <div class="price-value" v-if="hasDiscounts">{{ $nf(priceAfterDiscount, 'currency' + currencyCode, 'cs-CZ') }}</div>
            <div :class="priceClass">{{ $nf(price, 'currency' + currencyCode, 'cs-CZ') }}</div>
        </div>
        <info-popup
            :show="showOvergrow"
            :title="$t('common.notInStock')"
            :message="$t('common.overgrow')"
            :button="$t('common.close')"
            @cancel="closeOvergrowPopup"
        ></info-popup>
        <confirm-delete-popup
            @confirm="submitDelete"
            @cancel="closeConfirmDeletePopup"
            :show="showConfirmPopup"
            :message="$t('components.ConfirmDeletePopup.title')"
        ></confirm-delete-popup>
    </div>
</template>

<script>
import ProductCounter from "./ProductCounter";
import ConfirmDeletePopup from "./ConfirmDeletePopup";
import InfoPopup from "@/components/InfoPopup";

export default {
        components: {InfoPopup, ConfirmDeletePopup, ProductCounter},
        props: ['item'],
        data: function() {
            return {
                showConfirmPopup: false,
                showOvergrow: false
            };
        },
        computed: {
            name: function () {
                return this.item.name;
            },
            quantity: function () {
                return this.item.quantity
            },
            size: function () {
                return '';
            },
            discounts: function () {
                return this.item.discounts;
            },
            hasDiscounts: function () {
                return this.item.discounts.length > 0
            },
            gifts: function () {
                return this.item.gifts;
            },
            hasGifts: function () {
                return this.item.gifts.length > 0
            },
            hasCustomTechnicalParameters: function () {
                return this.item.isCustom;
            },
            customTechnicalParameters: function () { // convert custom technical parameters unified format
                var _this = this;
                let params = [
                    {
                        type: 'size',
                        value: this.$t('common.customDimension'),
                    }
                ];
                var customData = this.item.itemCustomData;
                params.push({
                    type: 'dimensions',
                    value: customData.width + ' × ' + customData.length + ' ' + _this.$t('store.getters.cm')
                });
                params.push({
                    type: 'oxford-style',
                    value: customData.oxfordStyle ? _this.$t('common.oxfordStyle') : ''
                });
                return params;
            },
            technicalParameters: function () {
                var _this = this;
                let params = [];
                this.item.variantTechnicalParameters.forEach(function (technicalParameter) {
                    var tp = _this.$store.getters.convertTechnicalParameter(technicalParameter);
                    params.push(tp);
                });
                return params;
            },
            price: function () {
                if (this.item.isCustom) {
                    return this.item.totalPrice.priceWithVat * this.item.quantity;
                }
                return this.item.price.priceWithVat * this.item.quantity;
            },
            priceAfterDiscount: function () {
                if (this.item.isCustom) {
                    return this.item.totalPriceAfterDicount.priceWithVat * this.item.quantity;
                }
                return this.item.priceAfterDiscount.priceWithVat * this.item.quantity;
            },
            currency: function () {
                if (this.item.isCustom) {
                    return this.item.totalPrice.currency.htmlString;
                }
                return this.item.price.currency.htmlString;
            },
            currencyCode: function() {
                if (this.item.isCustom) {
                    return this.item.totalPrice.currency.code;
                }
                return this.item.price.currency.code;
            },
            priceClass(){
                let classes = ['price-value'];
                if (this.hasDiscounts) {
                    classes.push('price-value--stroke');
                }

                return classes;
            }
        },
        methods: {
            setQuanitity: function (value) {
                if(value < 1) {
                    this.openConfirmDeletePopup();
                    return;
                }
                const data = {
                    id: this.item.id,
                    quantity: value
                };
                this.$emit('setItemQuantity', data);
            },
            getTechnicalParameterValue: function (tp) {
                return tp.value;
            },
            getRemainingColumnsCount: function () {
                var tpNum = 0;
                if (this.hasCustomTechnicalParameters) {
                    tpNum = this.customTechnicalParameters.length;
                } else {
                    tpNum = this.technicalParameters.length;
                }

                let result = 4 - tpNum;
                if (result < 0) {
                    result = 0;
                }
                if (!this.hasGifts) {
                    result += 1;
                }
                if (!this.hasDiscounts) {
                    result += 1;
                }
                return result;
            },
            openConfirmDeletePopup() {
                this.showConfirmPopup = true;
            },
            closeConfirmDeletePopup() {
                if(this.quantity < 1) {
                    this.setQuanitity(1);
                }
                this.showConfirmPopup = false;
            },
            submitDelete() {
                this.$store.dispatch('removeBasketItem', {id: this.item.id})
                .then(function()  {
                    $('#basket-hidden-update').trigger('click');
                });
                this.showConfirmPopup = false;
            },
            showOvergrowPopup() {
                this.showOvergrow = true;
            },
            closeOvergrowPopup() {
                this.showOvergrow = false;
            }
        }
    };
</script>
